import React from 'react';

import classes from './NoItems.module.scss';

//No hay elementos para mostrar.

const NoItems = ({ Icon, title, description }) => {
  return (
    <div className={classes.container}>
      <Icon />
      <span className={`semibold-20 ${classes.title}`}>{title}</span>
      {description && <span className={`medium-16 ${classes.description}`}>{description}</span>}
    </div>
  );
};

export default NoItems;
